import React, { PropTypes } from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import '../../styles/core.scss';

export default class Navbar extends React.Component {

	toggleChosenByUser = (evt) => {
		const className = evt.target.className;

		let { isMariana, isBrumadinho, isAssistenciaTecnica } = this.props.choosenbyuser;

		if (className.includes('mariana')) isMariana = !isMariana;
		if (className.includes('brumadinho')) isBrumadinho = !isBrumadinho;
		if (className.includes('assistecnica')) isAssistenciaTecnica = !isAssistenciaTecnica;

		this.props.setChoosenByUser(isMariana, isBrumadinho, isAssistenciaTecnica);
	}

	greeting() {
		const hour = parseInt(moment().format("H"));
		if ( hour <= 12 && hour >= 6 ) return "Bom dia";
		else if ( hour <= 18 && hour >= 13 ) return "Boa tarde";
		else return "Boa noite";
	}
	renderDropdown() {
		// this.setState({ cadastrar: "teste" });

		if (this.props.projectaccess.length > 1) {
			// usuario pertence aos dois projetos
			// renderiza o dropdown com as opcoes de cadastrar brumadinho
			// e de cadastras mariana
			return (
				<li className="dropdown">
					<a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button">
						Cadastrar <span className="caret"></span>
					</a>
					<ul className="dropdown-menu">
						<li>
							<a href="/admin/documents/create/mariana"> Mariana</a>
						</li>
						<li>
							<a href="/admin/documents/create/brumadinho"> Brumadinho</a>
						</li>
					</ul>
				</li>
			);

		} else if ( this.props.projectaccess.length === 1 ) {
			// usuario presente em apenas um projeto
			let canAcess = this.props.projectaccess[0];
			canAcess = canAcess.split("_")[1];
			let urlCadastrar = "/admin/documents/create/" + canAcess;
			return (
				<li className="dropdown" >
					<Link to={urlCadastrar} >Cadastrar</Link>
				</li> );
		}
	}

	hasPermission() {
		const projetos = this.props.projectaccess;
		const fullUrl = window.location.href;
		if (fullUrl.includes("create") 		||
			fullUrl.includes("multimidia") 	||
			fullUrl.includes("ftp") 		||
			fullUrl.includes("manual")) {
			return;
		}
		
		// if (projetos.includes('access_mariana') && projetos.includes('access_brumadinho') ) {
		if (projetos.length > 1 ) {
			
			return (
				<div id="projectsPermiteds" className="checkbox">

					{projetos.includes('access_mariana') ? <label>
						<input type="checkbox"
							checked={this.props.choosenbyuser.isMariana}
							onChange={this.toggleChosenByUser}
							className="form-check-input mariana"

						/>
						Mariana
					</label> : null}

					{projetos.includes('access_brumadinho') ? <label>
						<input type="checkbox"
							checked={this.props.choosenbyuser.isBrumadinho}
							onChange={this.toggleChosenByUser}
							className="form-check-input brumadinho"
						/>
						Brumadinho
					</label> : null}

					{projetos.includes('access_assistencia_tecnica') ? <label>
						<input type="checkbox"
							checked={this.props.choosenbyuser.isAssistenciaTecnica}
							onChange={this.toggleChosenByUser}
							className="form-check-input assistecnica"
						/>
						Assis. Técnica
					</label> : null}
				</div>
			);
		}
	}

	renderManageUsers() {
		if (this.props.isAdmin) {
			return (
				<li><Link to="/admin/gerenciar_usuarios">Gerenciar Usuários</Link></li>
			);
		}
	}

	renderManageMapLayers() {
		if (this.props.isGisAdmin) {
			return (
				<li><Link to="/admin/gerenciar_maplayers">Gerenciar Camadas</Link></li>
			);
		}
	}

	renderMenuOptions() {
		if (this.props.isGisOnly) return null;

		return (
			<ul className="nav navbar-nav">
				{this.renderDropdown()}
				{/* <li className={this.props.pathname === "/admin/documents/create" ? 'active' : ''}>
					<Link to="/admin/documents/create">Cadastrar</Link>
				</li> */}
				<li className={this.props.pathname === "/admin/documents/view" ? 'active' : ''}>
					<Link to="/admin/documents/view">Documentos</Link>
				</li>
				{/* <li className={this.props.pathname === "/admin/multimidia" ? 'active' : ''}>
					<Link to="/admin/multimidia">Multimidia</Link>
				</li> */}
				<li className="dropdown">
					{/* TODO: MULTIMIDIA */}
					<a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button">
						Multimidia <span className="caret"></span>
					</a>
					<ul className="dropdown-menu">
						<li>
							<Link to="/admin/multimidia/mariana">Mariana</Link>
						</li>
						<li>
							<Link to="/admin/multimidia/brumadinho">Brumadinho</Link>
						</li>
					</ul>
				</li>
				<li className="dropdown">
					<a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button">
						Explorar <span className="caret"></span>
					</a>
					<ul className="dropdown-menu">
						<li>
							<Link to="/admin/documents/explorer">GIS</Link>
						</li>
						<li>
							<Link to="/admin/documents/ftp">Arquivos</Link>
						</li>
					</ul>
				</li>
				<li className="dropdown">
					<a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button">
						Ajuda <span className="caret"></span>
					</a>
					<ul className="dropdown-menu">
						<li>
							<Link to="/admin/manual">Manual</Link>
						</li>
					</ul>
				</li>

			</ul>
		);
	}

	render () {
		return (
			<nav className="navbar navbar-default">
				<div className="container-fluid">
					<div className="navbar-header">

						{/* Toggle Button */}
						<button
							type="button"
							className="navbar-toggle collapsed"
							data-toggle="collapse" data-target="#cs-navbar-collapse" aria-expanded="false">
							<span className="sr-only">Toggle navigation</span>
							<span className="icon-bar"></span>
							<span className="icon-bar"></span>
							<span className="icon-bar"></span>
						</button>

						{/* Icon Brand */}
						<a className="navbar-brand" style={{height: "50px", paddingTop: "9px", paddingBottom: "9px"}}
							href="/">
							<img alt="Brand" src="/coppelogo.png" height="32px" />
						</a>

					</div>
					<div className="collapse navbar-collapse" id="cs-navbar-collapse">

						<p className="navbar-text" style={{color: "#910b26", fontWeight: "bold"}}>
							Repositório Dinâmico de Documentos Georreferenciados
						</p>

						{this.renderMenuOptions()}

						<div className="navbar-right">
							{this.hasPermission(this.props.projectaccess)}
							<p className="navbar-text" >
								<span>{this.greeting()}, {this.props.username}!</span>
							</p>
							<ul className="nav navbar-nav">
								<li className="dropdown">
								</li>
								<li className="dropdown">
									<a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button">
										<span className="caret"></span>
									</a>
									<ul className="dropdown-menu">
										<li><Link to="/admin/change_password">Trocar Senha</Link></li>
										{this.renderManageUsers()}
										{this.renderManageMapLayers()}
										<li onClick={() => this.props.logout()}><a>Sair</a></li>
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</nav>
		);
	}
}

Navbar.propTypes = {
	username: PropTypes.string,
	isAdmin: PropTypes.bool,
	isGisAdmin: PropTypes.bool,
	isGisOnly: PropTypes.bool,
	pathname: PropTypes.string,
	projectaccess: PropTypes.array.isRequired,
	choosenbyuser: PropTypes.object.isRequired,
	logout: PropTypes.func.isRequired,
	setChoosenByUser: PropTypes.func.isRequired,
	canChangeUser: PropTypes.bool.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Home/Navbar.js